import StorageService from '@services/storage.service';

export default { // setter for state
    setSuperadminLoggedSchool(state) {
        state.superadminLoggedSchool = StorageService.getItem('superadminLoggedSchool', true, true);
    },

    setDistrictLoggedSchool(state) {
        state.districtLoggedSchool = StorageService.getItem('districtLoggedSchool', true, true);
    }
}
